import { useAiApiClient } from "#lib/AiApiClient.ts";
import { AiQueryKeys } from "#lib/AiQueryKeys.ts";
import { useSuspenseQuery } from "@tanstack/react-query";

export const useGetPersonalizationSuspenseQuery = () => {
    const { getPersonalization } = useAiApiClient();

    return useSuspenseQuery({
        queryKey: AiQueryKeys.GetPersonalization(),
        queryFn: async () => {
            return await getPersonalization();
        }
    });
};
